import { getMonitoredOfferCountsResourceQueryOptions } from "@/components/marketplace/monitored-offer-counts-query";
import { useDeferredResourceQuery } from "@/hooks/use-deferred-resource";
import { orpc } from "@/utils/orpc.client";

const compute = () => orpc.deals.computeMonitoredOfferCountsResource.call();

export function useMonitoredOfferCounts() {
  return useDeferredResourceQuery({
    queryOptions: getMonitoredOfferCountsResourceQueryOptions(),
    compute,
  }).value;
}
